import { render } from "./edit-product.vue?vue&type=template&id=10d5e436"
import script from "./edit-product.vue?vue&type=script&lang=js"
export * from "./edit-product.vue?vue&type=script&lang=js"

import "./edit-product.vue?vue&type=style&index=0&id=10d5e436&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__